import { useEffect, useState } from 'react';
import { StatTile } from '@/components/ui/stat-tile';
import { usePackages } from '../../../../hooks/usePackages';
import { translate } from '../../../../utils/Common';

// graph paquetes entregados por plataforma
const GraphPackagesReturnedByPlatform = () => {
    const { getStatsXMonth } = usePackages();
    const [cantPackages,setCantPackages] = useState(null);

    const getData = async () => {
        const abortController = new AbortController();
        try {
            
            const dataToSend = {
                "month" : new Date().getMonth() + 1,
                "year" : new Date().getFullYear()
            }

            const response = await  getStatsXMonth(abortController.signal, dataToSend);
            const result = getTotalPackagesReturned(response?.payload);            
            setCantPackages(result);
        } catch (error) {
            console.error(error);
            }

    }

    const getTotalPackagesReturned = (listPlatf) => {
        if (listPlatf) {
            if (listPlatf.length > 0) {
                let cantTotal = 0;
                listPlatf.map((plataforma) => cantTotal += plataforma.paquetes_reversa);
                return cantTotal;
            }
            else return 0;
        }
        else return 0;
    }

    useEffect(() => {
        getData();
        }, []);

    return (
        <StatTile
            loading={cantPackages === null}
            value={cantPackages}
            label={translate("global.packagesReverseXYear")}
        />
    );
};

export default GraphPackagesReturnedByPlatform;